module.exports = __webpack_public_path__ + "static/blog-2-4bb2ea35c97bdba7ad6fb290df660a6a.jpg";